"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseTranslation = require("nicbase-translation");

var _filterChips = _interopRequireDefault(require("../filter-chips"));

var _filterableSelectionList = _interopRequireDefault(require("../filterable-selection-list"));

var _excluded = ["hideServiceStations"],
    _excluded2 = ["selectedRows", "hideServiceStations"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SERVICE_STATIONS = ['schmitz', 'carrier', 'thermoking', 'railWorkshop'];

var sort = function sort(prev, next) {
  var _prev$label;

  return String((_prev$label = prev.label) !== null && _prev$label !== void 0 ? _prev$label : '').localeCompare(next.label);
};

var PoiSelectionList = function PoiSelectionList(_ref) {
  var hideServiceStations = _ref.hideServiceStations,
      other = _objectWithoutProperties(_ref, _excluded);

  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal.id;

  var _usePortalPois = (0, _hooks.usePortalPois)(portalId, null, {
    enabled: Boolean(portalId),
    select: function select(pois) {
      var poisForFilter = pois;

      if (hideServiceStations) {
        poisForFilter = pois.filter(function (poi) {
          var _poi$category;

          return !SERVICE_STATIONS.includes((_poi$category = poi.category) === null || _poi$category === void 0 ? void 0 : _poi$category.icon);
        });
      }

      return poisForFilter.map(function (_ref2) {
        var id = _ref2.id,
            name = _ref2.name;
        return {
          value: id,
          label: name
        };
      }).sort(sort);
    }
  }),
      poiInfos = _usePortalPois.data;

  return /*#__PURE__*/_react["default"].createElement(_filterableSelectionList["default"], _extends({}, other, {
    data: poiInfos,
    filterInputLabel: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "filters.searchPoi"
    })
  }));
};

PoiSelectionList.propTypes = _objectSpread(_objectSpread({}, _filterableSelectionList["default"].propTypes), {}, {
  hideServiceStations: _propTypes["default"].bool
});
PoiSelectionList.defaultProps = {
  hideServiceStations: false
};

var PoiChips = function PoiChips(_ref3) {
  var selectedRows = _ref3.selectedRows,
      hideServiceStations = _ref3.hideServiceStations,
      other = _objectWithoutProperties(_ref3, _excluded2);

  var _usePortal2 = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal2.id;

  var _usePortalPois2 = (0, _hooks.usePortalPois)(portalId, null, {
    enabled: Boolean(portalId),
    select: function select(pois) {
      var poisForFilter = pois;

      if (hideServiceStations) {
        poisForFilter = pois.filter(function (poi) {
          var _poi$category2;

          return !SERVICE_STATIONS.includes((_poi$category2 = poi.category) === null || _poi$category2 === void 0 ? void 0 : _poi$category2.icon);
        });
      }

      return poisForFilter.map(function (_ref4) {
        var id = _ref4.id,
            name = _ref4.name;
        return {
          value: id,
          label: name
        };
      }).sort(sort);
    }
  }),
      poiInfos = _usePortalPois2.data;

  var chipData = selectedRows.map(function (value) {
    return poiInfos === null || poiInfos === void 0 ? void 0 : poiInfos.find(function (poi) {
      return poi.value === value;
    });
  }).filter(function (poi) {
    return poi;
  });
  return /*#__PURE__*/_react["default"].createElement(_filterChips["default"], _extends({}, other, {
    data: chipData
  }));
};

PoiChips.propTypes = {
  selectedRows: _propTypes["default"].arrayOf(_propTypes["default"].number),
  hideServiceStations: _propTypes["default"].bool
};
PoiChips.defaultProps = {
  selectedRows: [],
  hideServiceStations: false
};
PoiSelectionList.Chips = PoiChips;
var _default = PoiSelectionList;
exports["default"] = _default;